import React, { Component } from 'react'
import InputTextAreaUI from './InputTextAreaUI.js'

class InputTextAreaSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value,
      clientError: null
    }
  }

  render() {
    return (
      <InputTextAreaUI
        type={this.props.type}
        name={this.props.name}
        value={this.props.value}
        onChange={this.props.onChange}
        label={this.props.label}
        help={this.props.help}
        messageList={this.props.messageList}
        labelKey={this.props.labelKey}
        helpKey={this.props.helpKey}
        required={this.props.required}
        error={this.state.clientError || this.props.error}
        setClientError={this.setClientError}
        autoFocus={this.props.autoFocus}
      />
    )
  }

  // this is used in FormSF (dynamically) to change border color
  setClientError = (clientError) => {
    this.setState({ clientError: clientError })
  }

}

export default InputTextAreaSF
